import {BlockType} from "../../model/markdown/MarkdownText"
import {ParsedBlock} from "./blockParseService"

class QuoteBlockParserService {
    isQuoteBlock(curChar: string): boolean {
        return curChar === '>'
    }

    getBlock(line: string, offset: number, identOffset: number, indent: number, lines: Array<string>, lineNo: number): ParsedBlock {
        offset++
        identOffset++
        if (offset < line.length) {
            offset++
            identOffset++
        }
        const offsets: Array<number> = []
        const contents: Array<string> = []

        while (lineNo < lines.length) {
            const checkLine = lines[lineNo]
            if (!this.isQuoteBlock(checkLine[0])) {
                break
            }
            let lineOffset = 1
            while (lineOffset < checkLine.length && checkLine[lineOffset] === ' ') {
                lineOffset++
            }

            offsets.push(lineOffset)
            contents.push(checkLine.substring(lineOffset))
            lineNo++
        }
        const subBlocks: Array<ParsedBlock> = []
        for (let i = 0; i < offsets.length; i++) {
            subBlocks.push({
                type: BlockType.QUOTE,
                offset: offsets[i],
                content: contents[i],
                subBlocks: [],
                lineSkipped: 0,
                startFrom: 1,
                hint: '',
                indent: 0
            })
        }

        return {
            type: BlockType.QUOTE,
            offset: offset,
            content: line.substring(offset),
            lineSkipped: offsets.length + 1,
            subBlocks,
            startFrom: 1,
            hint: '',
            indent: 0
        }
    }
}

export const quoteBlockParserService = new QuoteBlockParserService()
